module.exports = __webpack_public_path__ + "static/media/hydra-guard.57bd71c9.png";